<template>
  <div class="main-container faq">
    <div class="row">
      <div class="col faq-accordion-holder">
        <h3 class="accordion-header" v-if="header">{{ header }}</h3>
        <div class="accordion accordion-flush" id="faq">
          <div class="accordion-item" v-for="(item, index) in faq" :key="index">
            <h3 :id="`flush-headin${index}`">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="`#flush-collapse${index}`"
                :aria-controls="`flush-collapse${index}`"
              >
                <span v-html="item.questionTitle"></span>
              </button>
            </h3>
            <div
              :id="`flush-collapse${index}`"
              class="accordion-collapse collapse"
              :aria-labelledby="`flush-headin${index}`"
              data-bs-parent="#faq"
            >
              <div class="accordion-body">
                <p class="m-0" v-html="item.questionAnswer"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FAQ",
  data() {
    return {
      show: this.defaultOpen || false,
    };
  },
  props: {
    header: String,
    faq: [Array],
  },
};
</script>
<style lang="scss">
.main-container {
  font-family: var(--micrositeTypeStyle);

  &.faq {
    // background: unset !important;
    background-color: var(--background-3);
    padding: 30px 40px;

    @include media-breakpoint-down(md) {
      padding: 30px 30px;
    }
  }
}

.faq {
  .col {
    &.faq-accordion-holder {
      padding: 0;
    }
  }
}

.faq .accordion-body {
  font-weight: 400;
  color: var(--primaryText);
}

.faq h2,
.faq h3 {
  color: var(--primaryText);
  font-weight: 700;
}
.faq h2 {
  font-size: 30px;
  line-height: 120%;
}
.accordion-body p {
  font-size: 15px;
  line-height: 150%;
}
.faq {
  h3.accordion-header {
    font-size: 30px;
    line-height: 150%;
    margin-bottom: 20px;
  }

  .accordion-button {
    font-size: 15px;
    line-height: 150%;
    color: var(--primaryText);
  }
}

.faq h3,
.faq .accordion-body {
  font-size: 15px;
  line-height: 150%;
}
.faq .accordion-button {
  padding: 20px 10px 20px 0;
}
.faq h2,
.faq .accordion-body {
  padding: 0px 0 20px 0;
}
.faq {
  // margin-top: 30px;
  // margin-bottom: 30px;
}

.faq .accordion-button:not(.collapsed) {
  background-color: #fff;
  color: var(--primaryText);
  box-shadow: none;
}
.faq .accordion-button:focus {
  border-color: none !important;
  box-shadow: none !important;
}
.faq .accordion-button:focus-visible {
  border: 1px solid;
  box-shadow: none !important;
  color: $primary-text;
}
</style>
